import React from 'react';
import './CartView.scss';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import {ItemForSeat} from '../model/Seating';
import {matrixConfigState} from '../state';
import {useRecoilValue} from 'recoil';
import {FormattedDate} from 'react-intl';
import { formatDate, formatTimeRange } from './cart/formatUtils';

type CartViewEntryHeaderProps = {
    item: ItemForSeat;
    removeAction: () => void;
    countdownText?: string;
    index?: number;
};


const buildTicketSummary = (item: ItemForSeat, index?: number, countdownText?: string): string => {
    const parts: string[] = [];

    if (index !== undefined) {
        parts.push(`Ticket ${index + 1}`);
    }
    if (item.longDates) {
        parts.push(item.longDates);
    }
    if (item.area) {
        parts.push(`Bereich ${item.area}`);
    }
    if (item.row) {
        parts.push(`Reihe ${item.row}`);
    }
    if (item.label) {
        parts.push(`Platz ${item.label}`);
    }
    if (countdownText) {
        parts.push(`reserviert für ${countdownText}`);
    }

    return parts.filter(Boolean).join(', ');
};


const SeatingCartItemHeader: React.FC<CartViewEntryHeaderProps> = ({item, removeAction, countdownText, index}) => {
    const summary = buildTicketSummary(item, index, countdownText);

    return (
        <>
            <div className="badge bg-secondary-custom set-name w-100">
                {item.setName?.split('\\n').map((line, i) => (
                    <span key={i}>{line}<br/></span>
                ))}
            </div>
            <div className="row">
                <div className="col-11">
                    <strong>{item.longDates}</strong><br/>
                    {item.area && (
                        <span><strong>Bereich</strong> {item.area}, </span>
                    )}
                    <span><strong>Reihe</strong> {item.row}, </span>
                    <span><strong>Platz</strong> {item.label}</span>
                </div>
                <div className="col-1">
                <button type="button" className="btn-close" aria-label={`${summary}. Ticket entfernen`} onClick={removeAction}/>
                </div>
            </div>
        </>
    )
};

const PytCartItemHeader: React.FC<CartViewEntryHeaderProps> = ({ item, removeAction, countdownText, index }) => {

    // Der folgende code funktioniert nur für vollständige selektierte Items,
    // daher hier aussteigen, wenn kein solches in der Hand halten.
    if (item.status === 'PENDING') {
        return null;
    }

    const date = formatDate(item.row?.split('|')[0]) ?? '';
    const time = formatTimeRange(item.row?.split('|')[1]?.replace('-', ' - ')) ?? '';
    const area = item.area ? item.area : '';

    // Einzelne Ticket-Elemente zu einer Zusammenfassung zusammenfügen.
    // Leere Elemente nicht ausgeben: filter(Boolean)
    const summaryParts = [
        index !== undefined ? `Ticket ${index + 1}` : '',
        area,
        item.setName ?? '',
        date ? ` ${date}` : '',
        time ? ` Einlasszeit ${time}` : '',
        'im Warenkorb',
        countdownText ? `reserviert für ${countdownText}` : ''
    ].filter(Boolean);

    const summary = summaryParts.join(', ');

    return (
        <>
            <div className="badge bg-secondary-custom set-name w-100">{item.setName}</div>
            <div className="row">
                <div className="col-11">
                    {item.area && (<><strong>{item.area}</strong><br/></>)}
                    <strong><FormattedDate
                        value={item.row.split('|')[0]}
                        year="numeric" month="numeric" day="numeric" weekday="long"
                    /></strong><br/>
                    <strong>{item.row.split('|')[1].replace('-', ' - ')}</strong><br/>
                </div>
                <div className="col-1">
                    <button type="button" className="btn-close" aria-label={`${summary}. Ticket entfernen`} onClick={removeAction}/>
                </div>
            </div>
        </>
    );
};

const CartViewEntryHeader: React.FC<CartViewEntryHeaderProps> = props => {
    const matrixConfig = useRecoilValue(matrixConfigState);

    const Header: React.FC<CartViewEntryHeaderProps> =
        matrixConfig?.mode === 'normal'
            ? SeatingCartItemHeader
            : PytCartItemHeader;

    return (
        <div className="toast-header">
            <div className="cart-form-entry-header w-100">
                <Header {...props}/>
            </div>
        </div>
    );
}

export default CartViewEntryHeader;
